import QuestionItemHeader from "pages/ManagementPage/questionSection/questionItemCard/QuestionItemHeader/QuestionItemHeader";

export default QuestionItemHeader;
